import Vue from 'vue'
import Router from 'vue-router';
const NotFound = () => import('./views/NotFound.vue');
const Preview = () => import('./views/Preview.vue');
// const Tutorial = () => import('./views/Tutorial.vue');
const Page = () => import('./views/Page.vue');
const Post = () => import('./views/Post.vue');
const Author = () => import('./views/Author.vue');
const ListSearch = () => import('./views/ListSearch.vue');
// const PostTable = () => import('./views/PostTable.vue');
const Tag = () => import('./views/Tag.vue');

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: { name: 'listsearch' }
    },
    {
      path: '/not-found',
      name: 'not-found',
      component: NotFound
    },
    {
      path: '/page/:uid',
      name: 'page',
      component: Page
    },
    {
      path: '/tutorials/:uid',
      name: 'post',
      component: Post
    },
    // {
    //   path: '/posttable/:uid',
    //   name: 'posttable',
    //   component: PostTable
    // },
    {
      path: '/tutorials/author/:uid',
      name: 'author',
      component: Author
    },
    {
      path: '/tutorials/tag/:tag',
      name: 'tag',
      component: Tag
    },
    {
      path: '/tutorials',
      name: 'listsearch',
      component: ListSearch
    },
    {
      path: '/preview',
      name: 'preview',
      component: Preview
    },
/*    {
      path: '/tutorial_old',
      name: 'tutorial',
      component: Tutorial
    },*/
    {
      path: '*',
      redirect: { name: 'not-found' }
    }
  ]
})
